import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=6a2a0c60&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=6a2a0c60&prod&scoped=true&lang=css"
import style1 from "./Transactions.vue?vue&type=style&index=1&id=6a2a0c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a0c60",
  null
  
)

export default component.exports